
// Components
import Slider1 from '../../Sliders/Slider-1';
import Slider2 from '../../Sliders/Slider-2';
import Slider3 from '../../Sliders/Slider-3';
import Slider4 from '../../Sliders/Slider-4';
import Section1 from '../../Sections/Section-1';
import Section2 from '../../Sections/Section-2';
import Section3 from '../../Sections/Section-3';

const Home = () => {
    return (
        <>

            {/* Slider 1 */}
            <Slider1></Slider1>

            {/* Slider 2 */}
            <Slider2></Slider2>

            {/* Section 1 */}
            <Section1></Section1>

            {/* Section 2 */}
            <Section2></Section2>

            {/* Slider 3 */}
            <Slider3></Slider3>

            {/* Slider 4 */}
            <Slider4></Slider4>

            {/* Section 3 */}
            <Section3></Section3>

        </>
    )
}

export default Home;